export default "__VITE_ASSET__DuP3GVPq__"